var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Snackbar',{attrs:{"show":_vm.mostrarSnackbar}}),_c('router-view'),(_vm.isMainRoute)?_c('RefExtras'):_vm._e(),_c('ChatsHelexium')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }